// Hàm thuần dùng chung cho lưới, hộp chi tiết, ConceptPicker và ProductCard.
import type { LookbookConcept, LookbookCostume, LookbookImage } from "./api";

export const MAX_LOOKBOOK_IMAGES = 10;

export function sortImages(images: readonly LookbookImage[]): LookbookImage[] {
  return images.slice().sort((a, b) => a.position - b.position);
}

/** Ảnh đại diện = position 1 (BE giữ liên tục 1..n). Không ảnh → undefined. */
export function coverImageOf(item: Pick<LookbookConcept, "images"> | Pick<LookbookCostume, "images">): string | undefined {
  return sortImages(item.images)[0]?.url;
}

export function conceptSearchText(c: LookbookConcept): string {
  return [c.name, c.tone, c.mood, c.suggest, c.tags.join(" "), c.product?.name ?? "", c.id]
    .join(" ")
    .toLowerCase();
}

export function costumeSearchText(c: LookbookCostume): string {
  return [c.name, c.type, c.color, c.sizes.join(" "), c.sizeNotes].join(" ").toLowerCase();
}

/**
 * Concept kiểu gói (GNCA) là bóng của sản phẩm: tên/giá/bật-tắt sửa ở trang Sản phẩm.
 * Ở lookbook chỉ được thêm ảnh và ghi chú — không đổi tên, không xoá.
 */
export function isEditableConcept(c: Pick<LookbookConcept, "kind">): { fields: boolean; remove: boolean } {
  const style = c.kind === "style";
  return { fields: style, remove: style };
}

/**
 * Tên 12 concept gốc — CHỈ dùng làm dự phòng khi `GET /concepts` hỏng, để form
 * tạo đơn vẫn chọn được concept (không ảnh, không lọc chi nhánh) thay vì trống.
 * Nguồn: DEFAULT_CONCEPTS cũ (đã di trú vào bảng `concepts` bởi migration 0217).
 */
export const LEGACY_CONCEPT_NAMES: Readonly<Record<string, string>> = {
  toi_gian: "Tối Giản",
  hien_dai: "Hiện Đại",
  co_dien: "Cổ Điển",
  bieu_tuong: "Biểu Tượng",
  vi_the: "Vị Thế",
  chan_dung: "Chân Dung Cá Nhân",
  nen_xam: "Nền Xám",
  nen_trang: "Nền Trắng",
  ban_be: "Concept Bạn Bè",
  doi: "Concept Đôi (Co-founder)",
  nen_do: "Nền Đỏ",
  cv_basic: "CV Basic",
};

/** Tên concept theo mã — tra kho trước, rơi về danh sách gốc, cuối cùng trả lại mã. */
export function conceptNameOf(id: string, concepts: readonly { id: string; name: string }[] = []): string {
  return concepts.find((c) => c.id === id)?.name ?? LEGACY_CONCEPT_NAMES[id] ?? id;
}
